// extracted by mini-css-extract-plugin
module.exports = {"container":"ZulageListeEntryText_container__1TxJy","label":"ZulageListeEntryText_label__3ZPl8","inputWrapper":"ZulageListeEntryText_inputWrapper__CpD1p"};